import { ref } from 'vue'

const toasts = ref([])
let toastId = 0

const removeToast = (id) => {
    const index = toasts.value.findIndex((t) => t.id === id)
    if (index > -1) toasts.value.splice(index, 1)
}

const addToast = (type, message, duration = 3000) => {
    const toast = { id: ++toastId, type, message }
    toasts.value.push(toast)
    setTimeout(() => removeToast(toast.id), Math.max(duration, 1000))
    return toast.id
}

const clearAll = () => toasts.value.splice(0)

const extractErrorMessage = (error, fallback = 'An error occurred') => {
    if (error.response?.data) {
        const { message, errors } = error.response.data
        if (errors && typeof errors === 'object') {
            const msgs = []
            for (const [, fieldMsgs] of Object.entries(errors)) {
                const items = Array.isArray(fieldMsgs) ? fieldMsgs : [fieldMsgs]
                items.filter(Boolean).forEach((m) => {
                    msgs.push(`• ${m}`)
                })
            }
            if (msgs.length) {
                const header = message || 'Validation failed'
                return `${header}\n${msgs.join('\n')}`
            }
        }
        if (message) return message
    }
    return error.message || fallback
}

const showSuccess = (message, duration) => addToast('success', message, duration)
const showError = (messageOrError, fallback, duration) => {
    const msg = typeof messageOrError === 'string'
        ? messageOrError
        : extractErrorMessage(messageOrError, fallback)
    const lines = (msg.match(/\n/g) || []).length + 1
    const autoDuration = duration || Math.max(4000, lines * 1500)
    addToast('error', msg, autoDuration)
}
const showInfo = (message, duration) => addToast('info', message, duration)
const showWarning = (message, duration) => addToast('warning', message, duration)
const showDelete = (message, duration) => addToast('delete', message, duration)

export default function useToast() {
    return {
        toasts,
        addToast,
        removeToast,
        clearAll,
        extractErrorMessage,
        showSuccess,
        showError,
        showInfo,
        showWarning,
        showDelete,
    }
}
